module.exports = __webpack_public_path__ + "2acb60f2/img/chevron-down-icon.5542f65c.svg";